export class QuantityUomModel {
    id?: number;
    uomDisplay?: string;
    description?: string;
    isEnabled: boolean;
    sortOrder: number;
}

